import React from 'react';
import { TOUCH_LEVELS } from '../constants';

export const MeasurementSelector = ({ 
  measurementType,
  setMeasurementType,
  touchLevel,
  setTouchLevel,
  customHeight,
  setCustomHeight,
  error
}) => {
  return (
    <>
      {/* Measurement Type Selector */}
      <div className="flex gap-4 p-4 bg-gray-700/50 rounded-lg mb-6">
        <button
          onClick={() => setMeasurementType('touch')}
          className={`flex-1 py-2 px-4 rounded-lg transition-colors ${
            measurementType === 'touch'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-600 text-gray-300 hover:bg-gray-500'
          }`}
        >
          Touch Level
        </button>
        <button
          onClick={() => setMeasurementType('custom')}
          className={`flex-1 py-2 px-4 rounded-lg transition-colors ${
            measurementType === 'custom'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-600 text-gray-300 hover:bg-gray-500'
          }`}
        >
          Custom Height
        </button>
      </div>

      {/* Touch Level Selector */}
      {measurementType === 'touch' && (
        <div className="space-y-4 mb-6">
          <h3 className="text-sm font-medium text-gray-300">Select Touch Level</h3>
          <div className="grid grid-cols-1 gap-3">
            {TOUCH_LEVELS.map(level => (
              <button
                key={level.value}
                onClick={() => setTouchLevel(level.value)}
                className={`p-3 rounded-lg text-center transition-colors ${
                  touchLevel === level.value
                    ? level.selectedColor
                    : level.color
                }`}
              >
                {level.label}
              </button>
            ))}
          </div>
          {error && (
            <p className="text-sm text-red-400 mt-2">{error}</p>
          )}
        </div>
      )}

      {/* Custom Height Input */}
      {measurementType === 'custom' && (
        <div className="space-y-4 mb-6">
          <h3 className="text-sm font-medium text-gray-300">Custom Height</h3>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-gray-400 mb-2">Feet & Inches</label>
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="number"
                  value={customHeight.feet}
                  onChange={(e) => setCustomHeight(prev => ({
                    ...prev,
                    feet: e.target.value
                  }))}
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  min="0"
                  placeholder="Feet"
                />
                <input
                  type="number"
                  value={customHeight.inches}
                  onChange={(e) => setCustomHeight(prev => ({
                    ...prev,
                    inches: e.target.value
                  }))}
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  min="0"
                  max="11"
                  placeholder="Inches"
                />
              </div>
            </div>
            <div>
              <label className="block text-gray-400 mb-2">Or Meters</label>
              <input
                type="number"
                value={customHeight.meters}
                onChange={(e) => setCustomHeight(prev => ({
                  ...prev,
                  meters: e.target.value
                }))}
                className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                min="0"
                step="0.01"
                placeholder="Enter height in meters"
              />
            </div>
          </div>
          {error && (
            <p className="text-sm text-red-400 mt-2">{error}</p>
          )}
        </div>
      )}
    </>
  );
};

export default MeasurementSelector;